import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdEditInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";
import { config } from "config";

export const SeccionInfografiasEdit: React.FC<IResourceComponentsProps> = () => {

  
  const resourceLabel :string = 'Sub_seccion';
  const resourceName :string = 'seccionInfografia';
  const { id } = useForm();
  const childrenForms : ChildForm[] =[
    
  // {
  //   resourceName :"subSeccionInfografia",
  //   title : "Sub_seccion",
  //   field : "sub_id_seccion"
  // },
  ]

  return(
    <Cw8EditWrapper
      resourceLabel = {resourceLabel}
      resourceName = {resourceName}
      id = {id}
      childrenForms = {childrenForms}
    ></Cw8EditWrapper>
  )
    
};
